import Tooltip from 'bootstrap/js/dist/tooltip';

class TrialRequestIpInput {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.radios = self.elem.querySelectorAll('[data-trial-request-radio]');
        self.template = self.elem.querySelector('[data-trial-request-ip-template]');
        self.ipsContainer = self.elem.querySelector('[data-trial-request-ips-container]');
        self.ipFields = self.elem.querySelector('[data-trial-request-ip-fields]');
        self.addIpButton = self.elem.querySelector('[data-trial-request-add-ip]');
        self.firstIpInput = self.elem.querySelector('[data-trial-request-first-ip]');
        self.ipsInput = self.elem.querySelector('[data-trial-request-ips-input]');
    }

    init() {
        let self = this;

        self.checkRadiosValue();

        [...self.radios].map(radio => {
            radio.addEventListener('input', evt => {
                if(radio.value === 'ip') {
                    self.show();
                } else {
                    self.hide();
                }
            });
        });

        self.addIpButton.addEventListener('click', evt => {
            self.addIpInput();
        });

        self.listenForInputChange(self.firstIpInput);
    }

    checkRadiosValue() {
        let self = this;

        let checkedRadio = self.elem.querySelector('[data-trial-request-radio]:checked');

        if(checkedRadio && checkedRadio.value === 'ip') {
            this.show();
        }
    }

    show() {
        let self = this;

        self.ipsContainer.classList.remove('d-none');
        self.firstIpInput.disabled = false;
        self.firstIpInput.focus();
    }

    hide() {
        let self = this;

        self.ipsContainer.classList.add('d-none');
        self.firstIpInput.disabled = true;
    }

    addIpInput() {
        let self = this;

        let clone = self.template.content.cloneNode(true);

        self.listenForInputChange(clone.querySelector('[data-input-ip-address-list]'));

        self.ipFields.appendChild(clone);

        self.initRemoveIpButtons();
    }

    initRemoveIpButtons() {
        let self = this;

        // Remove existing event listeners from all buttons (by cloning them)
        self.removeAllEventListeners();

        // Get all the buttons
        let removeButtons = self.elem.querySelectorAll('[data-trial-request-ip-remove-btn]');

        [...removeButtons].map(button => {
            let parent = button.closest('[data-trial-request-ip]');

            // Instantiate tooltips on the remove buttons
            let tooltip = Tooltip.getOrCreateInstance(button);

            button.addEventListener('click', evt => {
                parent.remove();
                tooltip.dispose();
                self.updateInput();
            });
        });
    }

    listenForInputChange(input) {
        let self = this;

        input.addEventListener('input', evt => {
            self.updateInput();
        });
    }

    updateInput() {
        let self = this;
        
        let inputs = [...self.elem.querySelectorAll('[data-input-ip-address-list]')];

        let inputVals = [];

        inputs.map(input => {
            inputVals.push(input.value);
        });
        
        self.ipsInput.value = inputVals.join();
    }

    removeAllEventListeners() {
        let self = this;
        let buttons = self.elem.querySelectorAll('[data-trial-request-ip-remove-btn]');

        // Clone each button to remove its event listeners
        [...buttons].map(button => {
            let clone = button.cloneNode(true);
            button.parentNode.replaceChild(clone, button);
        });
    }
}

export default TrialRequestIpInput;
